<template>
  <ProSpaceRightPanel
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="competenceDirectory" v-slot:center>
      <ProSpacePanelBlock :header="headerCompetenceDirectories">
        <ProSpacePanelBlockList :list="content" :itemsPerPage="7" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="competenceDirectory" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
import { CompetenceDirectoryService } from "../../../services/CompetenceDirectoryService";
import { mapGetters } from "vuex";
import { useMultiSelectRightPanel } from "@composes/multiselect";
export default {
  name: "CompetenceDirectoryPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  setup() {
    const { selectedData } = useMultiSelectRightPanel();
    return {
      selectedData,
    };
  },
  data() {
    return {
      competenceDirectory: null,
      competenceDirectoryService: new CompetenceDirectoryService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerCompetenceDirectories() {
      return {
        title: this.$t("commonInformation"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.competenceDirectory) {
        return {
          title: this.competenceDirectory.name,
          id: this.selectedData.id,
          status: this.getStatus(this.competenceDirectory.status),
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        showCounter: false,
        cleareble: true,
      };
    },
    content() {
      if (this.competenceDirectory) {
        return [
          [
            {
              title: this.$t("competenceDirectoryBlock"),
              text: this.competenceDirectory.block,
            },
          ],
          [
            {
              title: this.$t("competenceDirectoryLevel"),
              text: this.competenceDirectory.level,
            },
          ],
          [
            {
              title: this.$t("competenceDirectoryType"),
              text: this.$t(this.competenceDirectory.type),
            },
          ],
          [
            {
              title: this.$t("competenceDirectoryDescription"),
              text: this.competenceDirectory.description,
              isHtml: true,
            },
          ],
          [
            {
              title: this.$t("competenceDirectoryAdvancementRecommendation"),
              text: this.competenceDirectory.advancementRecommendation,
              isHtml: true,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.competenceDirectory) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.competenceDirectory.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.competenceDirectory.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.competenceDirectory.createdAt) +
                " " +
                getAMorPM(this.competenceDirectory.createdAt, this.userinfo.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.competenceDirectory.lastUpdated) +
                " " +
                getAMorPM(this.competenceDirectory.lastUpdated, this.userinfo.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    selectedData: {
      deep: true,
      handler() {
        this.update();
      },
    },
  },
  methods: {
    update() {
      this.hasError = false;
      try {
        this.getCompetenceDirectory();
      } catch (e) {
        this.hasError = true;
      }
    },
    getCompetenceDirectory() {
      if (this.selectedData) {
        this.loading = true;
        this.competenceDirectoryService.get(this.selectedData.id).then((res) => {
          this.competenceDirectory = res.data;
          this.loading = false;
        });
      }
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.competenceDirectory);
    },
    deletePanel() {
      this.$emit("delete", this.competenceDirectory);
    },
    showHistoryPanel() {
      this.$emit("history", this.competenceDirectory);
    },
  },
};
</script>

<style scoped></style>
